import { render } from "./AdminAppSections.vue?vue&type=template&id=eb3cc76c&scoped=true&ts=true"
import script from "./AdminAppSections.vue?vue&type=script&lang=ts"
export * from "./AdminAppSections.vue?vue&type=script&lang=ts"

import "./AdminAppSections.vue?vue&type=style&index=0&id=eb3cc76c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb3cc76c"]])

export default __exports__